/* PDP Gallery + Description toggle
   - Horizontal swipe with scroll-snap
   - Thumb click switches main
   - Main click opens lightbox
   - Lightbox: swipe, arrow keys, tap to zoom, close
*/
(function(){
  const gal = document.querySelector('[data-gal]');
  if (!gal) return;

  const imgs = [...gal.querySelectorAll('[data-gal-img]')];
  const thumbs = [...gal.querySelectorAll('[data-gal-thumb]')];
  const counter = gal.querySelector('[data-gal-counter]');
  const expandBtn = gal.querySelector('[data-gal-expand]');
  const lightbox = document.querySelector('[data-gal-lightbox]');
  const lbTrack = lightbox?.querySelector('[data-gal-lb-track]');
  const lbCounter = lightbox?.querySelector('[data-gal-lb-counter]');
  const lbClose = lightbox?.querySelector('[data-gal-lb-close]');
  const lbPrev = lightbox?.querySelector('[data-gal-lb-prev]');
  const lbNext = lightbox?.querySelector('[data-gal-lb-next]');

  const total = imgs.length;
  let current = 0;

  function setActive(i) {
    if (i < 0 || i >= total) return;
    current = i;
    imgs.forEach((im, ii) => im.classList.toggle('active', ii === i));
    thumbs.forEach((t, ti) => t.classList.toggle('active', ti === i));
    if (counter) counter.textContent = (i + 1) + ' / ' + total;
    const activeThumb = thumbs[i];
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
    }
  }

  /* Thumb click swaps main image */
  thumbs.forEach((t, i) => {
    t.addEventListener('click', (e) => { e.preventDefault(); setActive(i); });
  });

  /* Click active main image -> lightbox */
  imgs.forEach((im, i) => {
    im.addEventListener('click', (e) => {
      if (!im.classList.contains('active')) return;
      e.preventDefault();
      openLightbox(current);
    });
  });
  expandBtn?.addEventListener('click', () => openLightbox(current));

  /* Swipe left/right on main image to change photo (mobile) */
  const mainBox = gal.querySelector('[data-gal-main]');
  let swipeX = null, swipeY = null;
  mainBox?.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) return;
    swipeX = e.touches[0].clientX;
    swipeY = e.touches[0].clientY;
  }, {passive: true});
  mainBox?.addEventListener('touchend', (e) => {
    if (swipeX === null) return;
    const dx = e.changedTouches[0].clientX - swipeX;
    const dy = e.changedTouches[0].clientY - swipeY;
    swipeX = null; swipeY = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      setActive(dx < 0 ? Math.min(current + 1, total - 1) : Math.max(current - 1, 0));
    }
  }, {passive: true});

  /* ===== LIGHTBOX ===== */
  let lbCurrent = 0;
  let lbSlides = [];
  let zoomState = { active: false, scale: 1, tx: 0, ty: 0 };

  function buildLightbox() {
    if (!lbTrack || lbSlides.length) return;
    imgs.forEach((img, i) => {
      const full = img.dataset.full || img.src;
      const lbSlide = document.createElement('div');
      lbSlide.className = 'pdp2-lb-slide';
      lbSlide.dataset.i = i;
      lbSlide.innerHTML = '<img src="' + full + '" alt="" draggable="false">';
      lbTrack.appendChild(lbSlide);
      lbSlides.push(lbSlide);
    });
  }

  function openLightbox(i) {
    if (!lightbox) return;
    buildLightbox();
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      lightbox.classList.add('open');
      goToLB(i, false);
    });
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
    resetZoom();
    setTimeout(() => { lightbox.hidden = true; }, 200);
  }
  function goToLB(i, smooth = true) {
    if (i < 0 || i >= lbSlides.length) return;
    lbCurrent = i;
    if (lbCounter) lbCounter.textContent = (i + 1) + ' / ' + lbSlides.length;
    const target = lbSlides[i];
    if (target && lbTrack) {
      lbTrack.scrollTo({left: target.offsetLeft, behavior: smooth ? 'smooth' : 'instant'});
    }
    resetZoom();
    setActive(i);
  }

  /* Lightbox track scroll -> update counter */
  let lbScrollTimeout;
  lbTrack?.addEventListener('scroll', () => {
    clearTimeout(lbScrollTimeout);
    lbScrollTimeout = setTimeout(() => {
      const w = lbTrack.clientWidth;
      const i = Math.round(lbTrack.scrollLeft / w);
      if (i !== lbCurrent) {
        lbCurrent = i;
        if (lbCounter) lbCounter.textContent = (i + 1) + ' / ' + lbSlides.length;
        setActive(i);
      }
    }, 60);
  });

  lbClose?.addEventListener('click', closeLightbox);
  lbPrev?.addEventListener('click', () => goToLB(lbCurrent - 1));
  lbNext?.addEventListener('click', () => goToLB(lbCurrent + 1));

  /* Close on backdrop click */
  lightbox?.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  /* Keyboard */
  document.addEventListener('keydown', (e) => {
    if (!lightbox || lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') goToLB(lbCurrent - 1);
    if (e.key === 'ArrowRight') goToLB(lbCurrent + 1);
  });

  /* Zoom on double-tap / dbl-click */
  function resetZoom() {
    zoomState = { active: false, scale: 1, tx: 0, ty: 0 };
    lbSlides.forEach(s => {
      const img = s.querySelector('img');
      if (img) {
        img.style.transform = '';
        img.classList.remove('zoomed');
      }
    });
  }
  lbTrack?.addEventListener('dblclick', (e) => {
    const img = e.target.closest('img');
    if (!img) return;
    if (zoomState.active) {
      resetZoom();
    } else {
      zoomState.active = true;
      zoomState.scale = 2.2;
      img.classList.add('zoomed');
      const rect = img.getBoundingClientRect();
      const ox = ((e.clientX - rect.left) / rect.width - 0.5) * -100;
      const oy = ((e.clientY - rect.top) / rect.height - 0.5) * -100;
      img.style.transform = 'scale(' + zoomState.scale + ') translate(' + ox + '%, ' + oy + '%)';
    }
  });

  /* Pinch-zoom (mobile) */
  let pinchStart = 0;
  lbTrack?.addEventListener('touchstart', (e) => {
    if (e.touches.length === 2) {
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      pinchStart = Math.hypot(dx, dy);
    }
  }, {passive: true});
  lbTrack?.addEventListener('touchmove', (e) => {
    if (e.touches.length === 2 && pinchStart) {
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      const dist = Math.hypot(dx, dy);
      const scale = Math.min(4, Math.max(1, dist / pinchStart * 1.5));
      const slide = lbSlides[lbCurrent];
      const img = slide?.querySelector('img');
      if (img) {
        img.style.transform = 'scale(' + scale + ')';
        img.classList.toggle('zoomed', scale > 1.1);
      }
    }
  }, {passive: true});

  /* Init */
  setActive(0);
})();

/* Description toggle */
(function(){
  const desc = document.querySelector('[data-desc]');
  if (!desc) return;
  const body = desc.querySelector('[data-desc-body]');
  const toggle = desc.querySelector('[data-desc-toggle]');
  const label = desc.querySelector('[data-desc-toggle-label]');
  if (!body || !toggle) return;

  const COLLAPSED_HEIGHT = 140;

  function apply(open) {
    if (open) {
      body.style.maxHeight = body.scrollHeight + 'px';
      body.classList.add('open');
      desc.classList.add('open');
      if (label) label.textContent = 'Show less';
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      body.style.maxHeight = COLLAPSED_HEIGHT + 'px';
      body.classList.remove('open');
      desc.classList.remove('open');
      if (label) label.textContent = 'Show full description';
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  /* Only collapse if content actually overflows */
  requestAnimationFrame(() => {
    if (body.scrollHeight <= COLLAPSED_HEIGHT + 20) {
      toggle.style.display = 'none';
      body.style.maxHeight = 'none';
      return;
    }
    apply(false);
  });

  toggle.addEventListener('click', () => {
    apply(!desc.classList.contains('open'));
  });
})();

/* Sticky ATC visibility — fixed slot above bottom nav, fade only (never slides
   over other bars). Shows when the primary ATC button is out of view. */
(function(){
  const sticky = document.querySelector('[data-sticky-atc]');
  const primaryATC = document.querySelector('#pdp-form .pdp2-btn-buy');
  if (!sticky || !primaryATC) return;
  sticky.style.opacity = '0';
  sticky.style.visibility = 'hidden';
  sticky.style.pointerEvents = 'none';
  sticky.style.transition = 'opacity 0.2s ease';
  const io = new IntersectionObserver((entries) => {
    const inView = entries[0].isIntersecting;
    if (inView) {
      sticky.style.opacity = '0';
      sticky.style.pointerEvents = 'none';
      setTimeout(() => { if (sticky.style.opacity === '0') sticky.style.visibility = 'hidden'; }, 220);
    } else {
      sticky.style.visibility = 'visible';
      sticky.style.opacity = '1';
      sticky.style.pointerEvents = 'auto';
    }
  }, { threshold: 0 });
  io.observe(primaryATC);
})();
